export function currentQuarter(d = new Date()) {
  const q = Math.floor(d.getMonth() / 3) + 1;
  return `${d.getFullYear()}-Q${q}`;
}

export function quarterOptions(count = 6) {
  const opts = [];
  const now = new Date();
  let year = now.getFullYear();
  let q = Math.floor(now.getMonth() / 3) + 1;
  for (let i = 0; i < count; i++) {
    opts.push(`${year}-Q${q}`);
    q -= 1;
    if (q < 1) { q = 4; year -= 1; }
  }
  return opts;
}

export function quarterLabel(q) {
  const [y, n] = q.split("-Q");
  return `${n}º Trimestre ${y}`;
}

export function currentMonth(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
